import { tablesDB, DATABASE_ID, STORE_TABLE_ID, Query, ID } from '../lib/appwrite';

export async function listStores(queries = []) {
  const res = await tablesDB.listRows(DATABASE_ID, STORE_TABLE_ID, queries);
  return res.rows || [];
}

export async function getStore(storeId) {
  return tablesDB.getRow(DATABASE_ID, STORE_TABLE_ID, storeId);
}

export async function createStore(data) {
  const storeId = data.storeId || ID.unique();
  const record = {
    storeId,
    storeName: data.storeName || 'New Store',
    ownerId: data.ownerId,
    storeSize: data.storeSize || 'small',
    district: data.district || '',
    region: data.region || '',
    ward: data.ward || '',
    street: data.street || '',
    tin: data.tin || '',
    surveyed: data.surveyed || 'no',
    isActive: data.isActive ?? false,
    road: data.road || '',
    buildingNumber: data.buildingNumber || '',
    contact: data.contact || '',
    businessNumber: data.businessNumber || '',
    documentFile: data.documentFile || '',
    unsurveyedAddress: data.unsurveyedAddress || '',
    imageUrl: data.imageUrl || '',
    createdAt: data.createdAt || new Date().toISOString(),
    ...(data.coordinates && { coordinates: data.coordinates }),
  };
  return tablesDB.createRow(DATABASE_ID, STORE_TABLE_ID, storeId, record);
}

export async function updateStore(storeId, data) {
  return tablesDB.updateRow(DATABASE_ID, STORE_TABLE_ID, storeId, data);
}

export async function deleteStore(storeId) {
  return tablesDB.deleteRow(DATABASE_ID, STORE_TABLE_ID, storeId);
}
